import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import RaisedButton from 'material-ui/RaisedButton';
import { updatePublishAt, orgInitialState } from 'redux/modules/groupPostCompose';
import { FormAccordionSection } from 'components';
import moment from 'moment';
import * as styles from './Group.scss';
import TimePicker from 'material-ui/TimePicker';
import DatePicker from 'material-ui/DatePicker';
var GScheduleArea = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    config: state.config,
    groupPost: state.groupPostCompose,
    organization: state.organization.current,
    organizationId: state.organization.current.id,
    timezone: state.organization.current.OrganizationTimezone && state.organization.current.OrganizationTimezone.details ? state.organization.current.OrganizationTimezone.details : {
      utc_offset: {
        hours: new Date().getTimezoneOffset() / 60
      }
    }
  };
}, {
  updatePublishAt: updatePublishAt
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(GScheduleArea, _Component);

  var _super = _createSuper(GScheduleArea);

  function GScheduleArea() {
    var _this;

    _classCallCheck(this, GScheduleArea);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getAdjustedTime", function (timestring) {
      return moment.utc(timestring).add(_this.props.timezone.utc_offset.hours, 'hours').add(_this.props.timezone.utc_offset.minutes, 'minutes');
    });

    _defineProperty(_assertThisInitialized(_this), "getUtcTime", function (timestring) {
      return moment.utc(timestring).subtract(_this.props.timezone.utc_offset.hours, 'hours').subtract(_this.props.timezone.utc_offset.minutes, 'minutes');
    });

    _defineProperty(_assertThisInitialized(_this), "handleDateSelect", function (incomingMoment) {
      var organizationId = _this.props.organizationId;
      var newMoment = moment(_this.props.groupPost.publishAt);
      newMoment.date(incomingMoment.date());
      newMoment.month(incomingMoment.month());
      newMoment.year(incomingMoment.year());

      _this.props.updatePublishAt(newMoment.valueOf(), organizationId);
    });

    _defineProperty(_assertThisInitialized(_this), "handleTimeSelect", function (incomingMoment) {
      var organizationId = _this.props.organizationId;

      _this.props.updatePublishAt(incomingMoment.valueOf(), organizationId);
    });

    return _this;
  }

  _createClass(GScheduleArea, [{
    key: "render",
    value:
    /** *********************************************************
     RENDER
     ***********************************************************/
    function render() {
      var _this2 = this;

      var _this$props = this.props,
          groupPost = _this$props.groupPost,
          organizationId = _this$props.organizationId;
      var publishAtMoment = this.getAdjustedTime(groupPost.publishAt);
      var formattedPostTime = /*#__PURE__*/React.createElement("span", {
        className: styles.postDateTime
      }, /*#__PURE__*/React.createElement("span", null, publishAtMoment.format('MMMM Do, YYYY')), /*#__PURE__*/React.createElement("span", {
        style: {
          marginLeft: 10
        }
      }, publishAtMoment.format('h:mm A')));
      return /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          width: '100%'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          width: '100%'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-3"
      }, /*#__PURE__*/React.createElement(DatePicker, {
        textFieldStyle: {
          cursor: 'pointer'
        },
        fullWidth: true,
        formatDate: function formatDate(d) {
          return moment(d).format('MMM D, YYYY');
        },
        hintText: "Publish Date",
        value: moment(groupPost.publishAt).toDate(),
        minDate: groupPost.minDate ? moment(groupPost.minDate).toDate() : undefined,
        maxDate: groupPost.maxDate ? moment(groupPost.maxDate).toDate() : undefined,
        onChange: function onChange(e, publishAt) {
          _this2.handleDateSelect(moment(publishAt));
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-1",
        style: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'left'
        }
      }, "at"), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-4"
      }, /*#__PURE__*/React.createElement(TimePicker, {
        textFieldStyle: {
          cursor: 'pointer'
        },
        fullWidth: true,
        pedantic: true,
        minuteStep: 5,
        hintText: "Publish Time",
        value: moment(groupPost.publishAt).toDate(),
        onChange: function onChange(e, publishAt) {
          _this2.handleTimeSelect(moment(publishAt));
        }
      }))));
    }
  }]);

  return GScheduleArea;
}(Component)) || _class);
export { GScheduleArea as default };